import { axiosInstance } from "@/api/axios";
import { EXPENSE_TYPE_FIELDS } from "@/constants/expenseType";
import { AxiosRequestConfig } from "axios";

export type CreateExpenseTypeFormValues = {
  name: string;
  description: string;
  required_fields: typeof EXPENSE_TYPE_FIELDS;
  available_fields?: typeof EXPENSE_TYPE_FIELDS; // Made optional
  worker_accessible: boolean;
};

export type UpdateExpenseTypeFormValues = {
  id: string;
} & CreateExpenseTypeFormValues;

export const getExpenseTypes = async (config?: AxiosRequestConfig) => {
  const params = config?.params;

  if (params?.sort) {
    params.sort = JSON.stringify(params.sort);
  }

  if (params?.filters) {
    params.filters = JSON.stringify(params.filters);
  }
  const response = await axiosInstance.get("/expenses/types", config);
  return response.data;
};

export const createExpenseType = async (data: CreateExpenseTypeFormValues) => {
  const response = await axiosInstance.post("/expenses/types", data);
  return response.data;
};

export const updateExpenseType = async (
  id: string,
  data: UpdateExpenseTypeFormValues
) => {
  const response = await axiosInstance.put(`/expenses/types/${id}`, data);
  return response.data;
};

export const deleteExpenseType = async (id: string) => {
  const response = await axiosInstance.delete(`/expenses/types/${id}`);
  return response.data;
};

export const restoreExpenseType = async (id: string) => {
  const response = await axiosInstance.post(`/expenses/types/${id}/reactivate`);
  return response.data;
};
